import React from 'react';
import '../styles/loading-spinner.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'medium' }) => (
  <div className={`tais-loading-spinner ${size !== 'medium' ? `tais-loading-spinner--${size}` : ''}`}>
    <div className="tais-loading-spinner__spinner" />
  </div>
);

export default LoadingSpinner;